import React from 'react';
import PropTypes from 'prop-types';
import styles from './tour.css';

const CustomTooltip = ({
    continuous,
    index,
    step,
    backProps,
    primaryProps,
    skipProps,
    tooltipProps,
    isLastStep,
    size
}) => (
    <div
        className={styles.tooltip}
        {...tooltipProps}
    >
        <div className={styles.header}>
            <h3 className={styles.title}>{step.title}</h3>
            <span className={styles.stepCount}>
                {index + 1}
                {' / '}
                {size}
            </span>
        </div>
        
        <div className={styles.content}>
            {step.content}
        </div>

        <div className={styles.footer}>
            <button
                className={styles.skipButton}
                {...skipProps}
            >
                {'Skip Tour'}
            </button>
            <div className={styles.buttons}>
                {index > 0 && (
                    <button
                        className={styles.backButton}
                        {...backProps}
                    >
                        {'Back'}
                    </button>
                )}
                <button
                    className={styles.nextButton}
                    {...primaryProps}
                >
                    {continuous && !isLastStep ? 'Next' : 'Finish'}
                </button>
            </div>
        </div>
    </div>
);

CustomTooltip.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    backProps: PropTypes.object,
    continuous: PropTypes.bool,
    index: PropTypes.number,
    isLastStep: PropTypes.bool,
    // eslint-disable-next-line react/forbid-prop-types
    primaryProps: PropTypes.object,
    size: PropTypes.number,
    // eslint-disable-next-line react/forbid-prop-types
    skipProps: PropTypes.object,
    // eslint-disable-next-line react/forbid-prop-types
    step: PropTypes.object,
    // eslint-disable-next-line react/forbid-prop-types
    tooltipProps: PropTypes.object
};

export default CustomTooltip;
